import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../app.service';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { JobsService } from '../../jobs/jobs.service';
import { UsersService } from '../../users/users.service';
import { RosterService } from '../roster.service';
import {
  getFormattedDate,
  isLargeScreen,
} from '../../../../../global.variable';
import { formatDate } from '@angular/common';

@Component({
  selector: 'gtapp-leave',
  standalone: false,
  templateUrl: './leave.component.html',
  styleUrl: './leave.component.scss',
})
export class LeaveComponent implements OnInit, OnDestroy {
  largeView = isLargeScreen;
  selectedDate = getFormattedDate();
  currentMonday = this.getMondayOfTheWeek();
  selectedWeekEnd = getFormattedDate();

  previousLeaveData: number = 0;
  rowsLeaveData: number = this.largeView ? 10 : 5;
  pageNumLeaveData: number = 1;
  totalPagesLeaveData: number = 0;
  totalRowsLeaveData: number = 0;

  userLeaveData: any = [];

  selectedItemIds = new Set();
  selectedUser: any = {};

  constructor(
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private userService: UsersService,
    private router: Router,
    private webSocketService: WebSocketService,
    private rosterService: RosterService,
    private jobService: JobsService,
  ) {}
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.onSelectedDateChange();
  }

  changeWeek(operation: '-' | '+' | 'today') {
    let selectedDay = this.selectedDate
      ? new Date(this.selectedDate)
      : new Date();

    selectedDay.setHours(0, 0, 0, 0);

    const week = 1000 * 60 * 60 * 24 * 7;
    if (operation == '-') {
      selectedDay = new Date(selectedDay.getTime() - week);
    } else if (operation == '+') {
      selectedDay = new Date(selectedDay.getTime() + week);
    } else {
      selectedDay = new Date();
    }
    this.selectedDate = getFormattedDate(selectedDay);

    this.onSelectedDateChange();
  }

  onSelectedDateChange() {
    this.selectedDate = this.getMondayOfTheWeek(
      this.selectedDate ? new Date(this.selectedDate) : new Date(),
    );

    const weekEnd = new Date(this.selectedDate);
    weekEnd.setDate(weekEnd.getDate() + 6);

    this.selectedWeekEnd = getFormattedDate(weekEnd);

    this.resetAndCallLeaveList();
  }
  getMondayOfTheWeek(date: Date = new Date()) {
    const monday = new Date(date);
    const day = monday.getDay(); // 0 = Sun

    const diff = day === 0 ? -6 : 1 - day;
    monday.setDate(monday.getDate() + diff);

    return getFormattedDate(monday);
  }
  resetAndCallLeaveList() {
    this.userLeaveData = [];
    this.previousLeaveData = 0;
    this.pageNumLeaveData = 1;
    this.getUsersLeaveListDataCount();
    this.getUsersLeaveList();
  }
  getStartEndDays() {
    const startDay = new Date(this.selectedDate);
    startDay.setHours(0, 0, 0, 0);
    const endDay = new Date(this.selectedWeekEnd);
    endDay.setHours(0, 0, 0, 0);

    return {
      start_day: formatDate(startDay, 'yyyy-MM-dd', 'en_US'),
      end_day: formatDate(endDay, 'yyyy-MM-dd', 'en_US'),
    };
  }
  getUsersLeaveListDataCount() {
    let params: any = {
      ...this.getStartEndDays(),
      get_count: 1,
    };
    if (this.selectedUser?.id) params.user_id = this.selectedUser?.id;
    this.rosterService.getAllLeaves(params).subscribe((response: any) => {
      this.totalRowsLeaveData = response?.total_size || 0;
    });
  }
  onChangePagination(event: any) {
    this.previousLeaveData = event.previous;
    this.pageNumLeaveData = event.pageNum;
    this.rowsLeaveData = event.pageSize;

    this.getUsersLeaveList();
  }
  getUsersLeaveList() {
    let params: any = {
      rows: this.rowsLeaveData,
      ...this.getStartEndDays(),
      previous: this.previousLeaveData || 0,
    };
    if (this.selectedUser?.id) params.user_id = this.selectedUser?.id;
    this.rosterService.getAllLeaves(params).subscribe((response: any) => {
      this.userLeaveData = response?.data || [];
    });
  }
  onSelectUser(userData: any) {
    this.selectedUser = userData;
    this.resetAndCallLeaveList();
  }

  onSelectItem(event: any, leaveData?: any) {
    const checked = event.target.checked;
    if (leaveData?.id) {
      if (checked) {
        this.selectedItemIds.add(leaveData?.id);
      } else {
        this.selectedItemIds.delete(leaveData?.id);
      }
    } else {
      if (checked) {
        this.selectedItemIds = new Set(
          this.userLeaveData?.map((item: any) => item?.id),
        );
      } else {
        this.selectedItemIds.clear();
      }
    }
  }
  onStatusChange(status: 1 | 2, leaveData?: any) {
    this.rosterService
      .updateLeave(
        { leave_status: status },
        {
          leave_ids: leaveData?.id
            ? [leaveData?.id]
            : [...this.selectedItemIds],
        },
      )
      .subscribe((response: any) => {
        this.getUsersLeaveList();
      });
  }
}
